import { ReactNode } from 'react';

interface ModalProps {
  title: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
}

export function Modal({ title, onClose, children, footer }: ModalProps) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2 style={{ marginBottom: 16 }}>{title}</h2>
        <div>{children}</div>
        {footer && <div className="row" style={{ justifyContent: 'flex-end', marginTop: 24 }}>{footer}</div>}
      </div>
    </div>
  );
}
